// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend_legend__2PRJS"};